import { debounce } from 'lodash';
import { useEffect, useState } from 'react';

function useScrollPosition() {
  const [scrollPosition, setScrollPosition] = useState(0);
  const [isAtBottomOfPage, setIsAtBottomOfPage] = useState(false);
  const [isNearBottomOfPage, setIsNearBottomOfPage] = useState(false);

  /* istanbul ignore next */
  const handleScroll = () => {
    const element = document.documentElement;
    const distanceFromBottom = Math.abs(element.scrollHeight - element.clientHeight - element.scrollTop);
    setScrollPosition(window.scrollY);
    setIsNearBottomOfPage(distanceFromBottom < 100);
    return distanceFromBottom < 1 ? setIsAtBottomOfPage(true) : setIsAtBottomOfPage(false);
  };
  const debouncedHandleScroll = debounce(handleScroll, 75);

  const recheckPosition = () => {
    debouncedHandleScroll();
  };

  useEffect(() => {
    window.addEventListener('scroll', debouncedHandleScroll);
    window.addEventListener('resize', debouncedHandleScroll);

    if (document.body.clientHeight < window.innerHeight) {
      setIsAtBottomOfPage(true);
      setIsNearBottomOfPage(true);
    }

    return () => {
      window.removeEventListener('scroll', debouncedHandleScroll);
      window.removeEventListener('resize', debouncedHandleScroll);
    };
  }, [debouncedHandleScroll]);

  return { isAtBottomOfPage, isNearBottomOfPage, scrollPosition, recheckPosition };
}

export default useScrollPosition;
